export default class CartItem {
    constructor(productId, img, title, count, price) {
        this.productId = productId
        this.img = img
        this.title = title
        this.count = count
        this.price = price
    }
}